var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { style: { "flex-direction": "column" } };
import bodyCanvas from "../../components/Canvas/CanvasTemplate.vue";
import { updateTaccuino } from "@/../../EshJSLib/services/taccuinoService";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { useRouter } from "vue-router";
import { patientStore } from '@/store/patient';
import { storeToRefs } from "pinia";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'taccuinoDetails',
    setup: function (__props) {
        var router = useRouter();
        var showLoading = ref(false);
        var alertModal = ref(null);
        var bodyCanvasElement = ref(null);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        function saveTaccuino(rowValue) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var userInput;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Salvare le modifiche ? ", true))];
                        case 1:
                            userInput = _b.sent();
                            if (userInput) {
                                showLoading.value = true;
                                updateTaccuino(rowValue)
                                    .then(function () {
                                    var _a;
                                    showLoading.value = false;
                                    store.fetchTaccuinos();
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Salvato con successo! ", false).then(function () { return router.push("/Registro/Taccuino"); });
                                })
                                    .catch(function (res) {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function resetTaccuino() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var userInput;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Ripristina modifiche ?", true))];
                        case 1:
                            userInput = _b.sent();
                            if (userInput) {
                                bodyCanvasElement.value.erase_dolore();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(bodyCanvas, {
                    ref_key: "bodyCanvasElement",
                    ref: bodyCanvasElement,
                    onOnSave: saveTaccuino,
                    onOnReset: resetTaccuino,
                    "outline-image": "male"
                }, null, 512),
                _createVNode(AlertModal, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512),
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
